













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class SelectInstanceButton extends Vue {
  @Prop() contractItem!: ContractItem;

  @Prop() disabled!: boolean;

  get tooltipText() {
    return 'Vincular instância ao item';
  }

  click() {
    this.$emit('click');
  }
}
